import React, { useState } from 'react';
import { ChevronDownIcon, ChevronUpIcon } from 'lucide-react';
const faqs = [{
  question: '¿Necesito comprar productos caros?',
  answer: '¡Para nada! Todo el método está diseñado para usar productos que encuentras en farmacias mexicanas (Similares, Del Ahorro, Guadalajara) por precios muy accesibles, generalmente entre $50 y $200 pesos.'
}, {
  question: '¿Sirve para piel sensible?',
  answer: 'Sí. El método de Skin-Cycling incluye días de recuperación específicos para proteger la barrera de tu piel. Sin embargo, siempre recomendamos hacer una prueba de parche antes de usar cualquier producto nuevo.'
}, {
  question: '¿Es un libro físico?',
  answer: 'No, es una guía digital (eBook) en formato PDF de alta calidad. La recibes en tu correo electrónico inmediatamente después de tu compra para que empieces hoy mismo.'
}, {
  question: '¿Cuánto tiempo tarda en verse resultados?',
  answer: "Muchas usuarias reportan una piel más suave desde la primera semana. El efecto 'Glass Skin' completo suele notarse tras completar el primer ciclo de 14 días."
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="w-full bg-cream py-16 md:py-24 px-4" data-id="element-27">
      <div className="max-w-3xl mx-auto" data-id="element-28">
        <h2 className="text-3xl md:text-4xl font-bold text-center text-brown-primary mb-12 font-serif" data-id="element-29">
          Preguntas Frecuentes
        </h2>

        <div className="space-y-4" data-id="element-30">
          {faqs.map((faq, index) => <div key={index} className="border border-brown-secondary/20 rounded-lg bg-white overflow-hidden" data-id="element-31">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex items-center justify-between p-6 text-left focus:outline-none" data-id="element-32">
                <span className="text-lg font-bold text-brown-primary" data-id="element-33">
                  {faq.question}
                </span>
                {openIndex === index ? <ChevronUpIcon className="w-5 h-5 text-rose-gold" data-id="element-34" /> : <ChevronDownIcon className="w-5 h-5 text-brown-secondary" data-id="element-35" />}
              </button>

              {openIndex === index && <div className="px-6 pb-6 text-brown-secondary leading-relaxed animate-in slide-in-from-top-2 duration-200" data-id="element-36">
                  {faq.answer}
                </div>}
            </div>)}
        </div>
      </div>
    </section>;
}